var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIconSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "twitter-icon-small_svg__a",
    d: "M.004 12.997h15.96V.047H.004z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "twitter-icon-small_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#twitter-icon-small_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.964 1.581a6.557 6.557 0 01-1.88.515 3.28 3.28 0 001.44-1.809 6.566 6.566 0 01-2.08.794A3.274 3.274 0 0011.053.048a3.273 3.273 0 00-3.19 4.015A9.304 9.304 0 011.11.646a3.267 3.267 0 001.014 4.365 3.266 3.266 0 01-1.484-.408v.041A3.273 3.273 0 003.27 7.85a3.285 3.285 0 01-1.48.056 3.278 3.278 0 003.06 2.271A6.579 6.579 0 010 11.531 9.282 9.282 0 005.02 13c6.025 0 9.32-4.982 9.32-9.303 0-.142-.004-.283-.01-.423a6.65 6.65 0 001.634-1.693",
    fill: "#5D9EC9",
    mask: "url(#twitter-icon-small_svg__b)"
  }))));
}
export default SvgTwitterIconSmall;